import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import SearchIcon from '@material-ui/icons/Search';
import { useHistory } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import * as track from '../../../lib/track';

const useStyles = makeStyles(theme => ({
  root: {
    height: '3rem',
    width: '30rem',
    padding: '1px 0px',
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    zIndex: 1,
    marginTop: '0.5rem',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    '& .Mui-focused': {
      border: `1px solid ${theme.palette.primary.main}`,
    },
  },
  input: {
    width: '100%',
    padding: '0.5rem 1rem',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '4px',
    marginRight: '1rem',
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.common.silver}`,
    '&>input::placeholder': {
      color: theme.palette.text.primary,
      opacity: 1,
    },
  },
  button: {
    borderRadius: '50%',
    minWidth: '3rem',
    width: '3rem',
    height: '3rem',
    boxShadow: 'none',
    padding: 0,
  },
}));

const SearchBar = () => {
  const classes = useStyles();
  let history = useHistory();

  const [inputValue, setInputValue] = React.useState('');

  const runSearch = () => {
    if (inputValue !== '') {
      const query = new URLSearchParams({search_text: inputValue}).toString();
      history.push(`/search?${query}`);
      track.sendEvent('home search bar', 'submit', {value: inputValue});
    }
  };

  const handleChange = event => {
    setInputValue(event.target.value);
  };

  const handleKeyPress = event => {
    if(event.key === 'Enter') {
      runSearch();
    }
  };

  return (
    <div className={classes.root}>
      <InputBase
        className={classes.input}
        placeholder="I am looking for..."
        inputProps={{ 'aria-label': 'search-providers' }}
        onChange={handleChange}
        onKeyUp={handleKeyPress}
        value={inputValue}
      />
      <Button
        variant="outlined"
        color="primary"
        aria-label="submit"
        onClick={runSearch}
        pointer="search"
        className={classes.button}
      >
        <SearchIcon />
      </Button>
    </div>
  );
};

export default SearchBar;
